
import AppStockEdit from "@/components/stock/StockEdit.vue";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			workingIDs: [] as number[],
		};
	},
	methods: {
		async cancel() {
			this.$router.push("/stock");
		}
	},
	async mounted() {
		let ids = this.$route.query.ids;
		if (ids) {
			this.workingIDs = JSON.parse(ids as string) as number[];
		}
		ToolbarService.title = this.$route.query.ids ? this.$ct("title-edit").toString() : this.$ct("title-add").toString();
	},
	components: {
		AppStockEdit
	},
	i18nEx: {
		componentPrefix: "components.stock"
	}
});
